/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Choice_Take_FeedInputs */

const cs_ebr_choice_take_feed = /** @type {(inputs: Ebr_Choice_Take_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převzít z feedu`)
};

const en_ebr_choice_take_feed = /** @type {(inputs: Ebr_Choice_Take_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take feed`)
};

/**
* | output |
* | --- |
* | "Take feed" |
*
* @param {Ebr_Choice_Take_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_choice_take_feed = /** @type {((inputs?: Ebr_Choice_Take_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Choice_Take_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_choice_take_feed(inputs)
	return cs_ebr_choice_take_feed(inputs)
});